import { Toast } from 'app/shared/toast/toast.service';
import { formatDate, formatSecondsAndOverflowToDays } from 'app/shared/utilities/time';
import { Format } from 'app/shared/utilities/TimestampFormatter';
import { TimeZone } from 'app/shared/time/TimeZone';

const WORLD_TIME_API_URL = 'https://worldtimeapi.org/api/timezone/Etc/UTC';

export type FetchFunction = (input: RequestInfo, init?: RequestInit) => Promise<Response>;

export type ShowToastFunction = (isCritical: boolean, message: string, title: string) => void;

export interface TimeSyncError {
    isCritical: boolean;
    message: string;
    title: string;
}

// TODO: I know, it's not great- $http.get() wanted to pre-flight the requests and this API won't support it
export async function requestUTCTime(
    fetchOverride: FetchFunction | null = null,
    abortSignal = undefined,
): Promise<Date> {
    const _fetch = fetchOverride ? fetchOverride : fetch;

    // Expect JSON: {... "utc_datetime": (ISO8601 string) ...}
    const response = await _fetch(WORLD_TIME_API_URL, {
        method: 'GET',
        mode: 'cors', // this API supports CORS, but only for GET requests (not OPTION)
        credentials: 'omit',
        redirect: 'error', // just in case something sneaky happens
        referrerPolicy: 'no-referrer', // they don't need to know about us
        keepalive: false,
        signal: abortSignal,
    });

    const data = await response.json();
    if (!data || !data.utc_datetime) {
        throw new Error('Internet time response was not valid');
    }

    return new Date(data.utc_datetime);
}

export function getAheadSeconds(source: number | null, destination: number | null): number | null {
    if (!(source && destination)) {
        return null;
    }

    return source - destination;
}

export function getDelta(source: string, destination: string, aheadSeconds: number): string {
    const direction = aheadSeconds > 0 ? 'ahead of' : 'behind';
    return `${source} ${direction} ${destination} by ${formatSecondsAndOverflowToDays(
        Math.abs(aheadSeconds),
    )} <br/>\n`;
}

export function formatDateToISO8601(date: Date): string {
    return formatDate(date, TimeZone.UTC.string, Format.ISO_8601);
}

export function showToast(isCritical: boolean, message: string, title: string): Toast {
    return new Toast(isCritical ? Toast.ERROR : Toast.WARNING, message, title, Toast.FOREVER);
}
